"use client"

import styled from "@emotion/styled"
import { Button, ButtonProps } from "@mui/material"
import Link from "next/link"
import { HTMLAttributeAnchorTarget } from "react"

const StyledButton = styled(Button)`
  font-size: 20px;
  min-width: 103px;
  height: 48px;
  max-width: fit-content;
  justify-self: center;
  border: 2px solid black;
  background-color: white;
  color: black;
  border-radius: 200px;
  text-decoration: none;
  min-width: 153px;
`

type Props = ButtonProps & {
  target?: HTMLAttributeAnchorTarget | undefined
}

const NewLobbyButton = (props: Props) => {
  return <StyledButton {...props} LinkComponent={Link} />
}
export default NewLobbyButton
